import React from 'react';

const styles = {
  Icon: {
    color: '#ffffff',
    fill: '#ffffff',
    fontSize: '37px',
    top: '148px',
    left: '26px',
    width: '37px',
    height: '37px',
  },
};

const IconComponent = () => (
  <svg style={styles.Icon} viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none" />
    {/* Document icon */}
    <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm0 2.5l3.5 3.5H14V4.5zM8 12h8v2H8v-2zm0 4h8v2H8v-2z" />
  </svg>
);

const defaultProps = {
  IconComponent,
};

const IconDocuments = (props) => {
  return props.IconComponent 
    ? <props.IconComponent style={styles.Icon} /> 
    : <defaultProps.IconComponent />;
};

export default IconDocuments;
